import { setModal } from "./actions";

export const setWeerdyModal = (modal) => async (dispatch) => {
  dispatch(setModal(modal));
};
